import { Component, NgModule, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxListModule } from 'devextreme-angular/ui/list';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { CommonService } from '../../services/common.service';
import { take, catchError } from 'rxjs/operators';
import { throwError, Subject, Observable } from 'rxjs';
import { BaseRequestService } from '../../services/base-request.service';
import { APIConfing } from '../../services/apiconfing.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services';
import { Router } from '@angular/router';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';

@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
  standalone: false
})

export class UserPanelComponent implements OnInit {
  @Input() menuItems: any;
  @Input() menuMode: string;
  getAuthInfo: any;
  getIMG: any;
  profileIMG = new Subject<any>();
  isShowChangePassword: boolean = true;

  constructor(public common: CommonService, public baseRequest: BaseRequestService,
    private router: Router, private enc: EncryptDecryptService,
    private toastrService: ToastrService, private authService: AuthService) {
    this.getAuthInfo = this.common.fnGetAuthInfo();
    this.common.getIsRefreshUserIMG$().subscribe((objIMG: any) => {
      if (objIMG === true) {
        this.fnGetProfileImgDetails();
      }
    });
  }
  ngOnInit() {
    this.fnGetProfileImgDetails();
    const isShow = localStorage.getItem(this.enc.encryptUsingAES256('Is_From_ChatBot')) === 'true' ? false : true;
    this.isShowChangePassword = isShow;
  }
  fnGetProfileImgDetails() {
    const getProfileImg: any = {
    };
    this.baseRequest.fnpost('/CSS/Consultant/GetConsultantPhotoDetails', getProfileImg)
      .pipe(take(1), catchError(err => throwError(err)))
      .subscribe((objRESP: any) => {
        if (objRESP && objRESP.code === this.baseRequest.status.success) {
          this.getIMG = objRESP.dataObject[0].photo;
          this.profileIMG = objRESP.dataObject[0].photo;
        } else if (objRESP.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
          this.getIMG = 'assets/img/avtar.png';
        } else if (objRESP.code === 'E001') {
          this.toastrService.error(objRESP.message, 'Error');
          this.getIMG = 'assets/img/avtar.png';
        } else if (objRESP.code === this.baseRequest.warning.code) {
          this.toastrService.warning(objRESP.message, 'Details');
          this.getIMG = 'assets/img/avtar.png';
        } else {
          this.getIMG = 'assets/img/avtar.png';
        }
      }, err => this.toastrService.error(APIConfing.data.E002, 'Error'));
  }
  getprofileIMG$(): Observable<any> {
    return this.profileIMG.asObservable();
  }
  add3Dots(name: string, limit: number) {
    const dots = '..';
    if (name && name.length > limit) {
      // you can also use substr instead of substring
      name = name.substring(0, limit) + dots;
    }
    return name;
  }
  fnLogOut() {
    this.authService.logout();
  }

  fnResetPassword() {
    this.router.navigate(['/Change-Password']);
  }

  fnOpenHelpDocs() {
    this.router.navigate(['/Help']);
  }


}

@NgModule({
  imports: [
    DxListModule,
    DxContextMenuModule,
    CommonModule
  ],
  declarations: [UserPanelComponent],
  exports: [UserPanelComponent]
})
export class UserPanelModule { }
